import React from "react";

export const Program = (props) => {
  return (
    <div id="program" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <h2>Program</h2>
        </div>
        <br></br>
        <div className="col-md-8 col-md-offset-2 text-justify-xs">
          <div className="program-text">
            <p>Full program (PDF): </p>
            <a href="pdfs/AAAA_2025-programme_book.pdf">
              DOWNLOAD PROGRAMME BOOK HERE
            </a>
            <p> </p>
          </div>
        </div>
      </div>
    </div>
  );
};
